import useChatStore from '@/Components/Chat/store';
import { useEffect, useState } from 'react';

/**
 * Custom hook to manage image files state and operations
 * @param {Object} store - MobX store
 * @returns {Object} Hook state and methods
 */
const useImageFiles = (store) => {
  const [files, setFiles] = useState([]);
  const [fileSelected, setFileSelected] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  const scrollToTop = () => {
    const container = document.getElementsByClassName(
      'infinite-scroll-component'
    )[0];
    if (container) {
      container.scrollTop = 0;
    }
  };

  const getFiles = async (page) => {
    try {
      setPage(page);
      const response = await store.api.get(`/file`, {
        params: {
          page: page,
          limit: 6,
          search: searchTerm,
          type: 'image', // Filter only images
        },
      });

      if (response.data.success) {
        const imageFiles = response.data.files.filter(
          (file) => file.type === 'image'
        );

        if (response.data.pagination.currentSearch) {
          if (page === 1) {
            setFiles(imageFiles);
          } else {
            setFiles([...files, ...imageFiles]);
          }
        } else {
          if (page === 1) {
            setFiles(imageFiles);
          } else {
            setFiles([...files, ...imageFiles]);
          }
        }
        setHasMore(response.data.pagination.next);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateVisibilityFile = async (file) => {
    try {
      const response = await store.api.put(`/file/visible`, {
        hash: file._id,
        visible: !file.visible,
      });

      if (response.data.success) {
        getFiles(1);

        // Update refFile in the chat if it exists
        const chatStore = useChatStore.getState();
        if (chatStore.refFile) {
          chatStore.updateRefFile((prevRefFile) =>
            prevRefFile
              ? prevRefFile.filter((f) => f.file !== file._id)
              : prevRefFile
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setFileSelected([]);
    setSelectedIndex([]);
  };

  const handleNext = () => {
    getFiles(page + 1);
  };

  const selectFile = (index, onlySelectedOne) => {
    const file = files[index];

    if (onlySelectedOne) {
      if (!selectedIndex.includes(index)) {
        setSelectedIndex([index]);
        setFileSelected([
          {
            ...files[index],
            enabled: true,
          },
        ]);
      } else {
        setSelectedIndex(selectedIndex.filter((item) => item !== index));
        setFileSelected(fileSelected.filter((file2) => file._id !== file2._id));
      }
    } else {
      if (!selectedIndex.includes(index)) {
        setSelectedIndex([...selectedIndex, index]);
        setFileSelected([
          ...fileSelected,
          {
            ...files[index],
            enabled: true,
          },
        ]);
      } else {
        setSelectedIndex(selectedIndex.filter((item) => item !== index));
        setFileSelected(fileSelected.filter((file2) => file._id !== file2._id));
      }
    }
  };

  useEffect(() => {
    getFiles(1);
    scrollToTop();
  }, [searchTerm]);

  return {
    files,
    fileSelected,
    selectedIndex,
    searchTerm,
    hasMore,
    page,
    handleInputChange,
    handleNext,
    selectFile,
    updateVisibilityFile,
    getFiles,
  };
};

export default useImageFiles;
